import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
type PlaceholderPageProps = {
  title: string;
  intent: string;
  sections: string[];
};

/**
 * Structure prévue pour les pages secondaires du site.
 * Le contenu détaillé et le design de ces pages restent à faire.
 */
export function PlaceholderPage({
  title,
  intent,
  sections
}: PlaceholderPageProps) {
  return <main className="bg-cream" data-id="element-116" data-mp="900f8v22ihom">
      <div className="mx-auto max-w-page px-6 py-20 lg:px-10 lg:py-28" data-id="element-117" data-mp="911tf8edrkak">
        <p className="text-xs uppercase tracking-[0.2em] text-sage-deep" data-id="element-118" data-mp="428hhkeqs1ci">Page prévue</p>
        <h1 className="mt-4 max-w-2xl font-serif text-4xl font-light leading-tight text-ink sm:text-5xl" data-id="element-119" data-mp="htdm70wyvjtp">{title}</h1>
        <p className="mt-5 max-w-xl text-[1.0625rem] leading-relaxed text-ink/70" data-id="element-120" data-mp="d12iro30pfwe">{intent}</p>

        <h2 className="mt-14 text-xs uppercase tracking-[0.2em] text-ink/45" data-id="element-121" data-mp="3lgvor8zq38z7">Contenus à prévoir</h2>
        <ol className="mt-5 max-w-xl divide-y divide-ink/15 border-y border-ink/15" data-id="element-122" data-mp="3hfagy221pkvv">
          {sections.map(section => <li key={section} className="py-3.5 text-ink/75" data-id="element-123" data-mp="17dsc43240fz9">
              {section}
            </li>)}
        </ol>

        <Link to="/" className="mt-12 inline-flex items-center gap-2 text-sm text-ink transition-colors duration-150 ease-soft hover:text-sage-deep" data-id="element-124" data-mp="1cb23ho9271pq">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="1m2ga0fzfh1sd" />
          Retour à l’accueil
        </Link>
      </div>
    </main>;
}